<template>
  <Card class="h-full">
    <template #title>
      <div class="text-xl">Custom Slogan</div>
    </template>
    <template #content>
      <div class="grid">
        <div class="flex flex-column gap-1 col-12">
          <label for="custom_slogan_text">Slogan Text </label>
          <InputText
            id="custom_slogan_text"
            :modelValue="customSloganText"
            @update:modelValue="$emit('update:customSloganText', $event)"
          />
        </div>
        <div class="flex flex-column gap-1 col-12">
          <label for="custom_slogan_link">Slogan Link</label>
          <InputText
            id="custom_slogan_link"
            :modelValue="customSloganLink"
            @update:modelValue="$emit('update:customSloganLink', $event)"
          />
        </div>
      </div>
    </template>
  </Card>
</template>

<script setup>
import Card from "primevue/card";
import InputText from "primevue/inputtext";

defineProps({
  customSloganText: {
    type: String,
    default: "",
  },
  customSloganLink: {
    type: String,
    default: "",
  },
});
defineEmits(["update:customSloganText", "update:customSloganLink"]);
</script>
